import { resolveUser } from '../../services/user';
import { IThunkActionCreator } from '../../types/thunk';
import { IUser } from '../../types/currentUser';
import { EUserActions } from './user';

export function updateUserDataAction(): IThunkActionCreator<Promise<IUser | null>> {
  return async (dispatch, getState, context) => {
    const { httpApi, logger, config } = context;

    const user = await resolveUser({ httpApi, logger, config });

    dispatch({ type: EUserActions.fetchUserDataSuccess, user });

    return user;
  };
}
